import styled from 'styled-components';

export const PdfContainer = styled.div`
    background: #f7f8fc;
    min-height: 100vh;
    padding: 80px 0 40px 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;

export const PdfWrapper = styled.div`
    max-width: 1200px;
    width: 100%;
    height: calc(100vh - 120px);
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 768px) {
        padding: 0 16px;
        height: calc(100vh - 100px);
    }
`;

export const BackButton = styled.button`
    background: #38A7BA;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        background: #2c5282;
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(56, 167, 186, 0.3);
    }

    &:active {
        transform: translateY(0);
    }

    @media screen and (max-width: 768px) {
        padding: 10px 20px;
        font-size: 14px;
    }
`;
